export default __webpack_public_path__ + "static/media/GSP2.742a55ec.png";